module.exports = "<div class=\"context-menu-wrapper\"\r\n\t[ngStyle]=\"contextMenuWrapperStyle\">\r\n\r\n\t<div class=\"remove-feature-wrapper\">\r\n\t\t<button class='removeFeature' (mousedown)=\"removeFeature($event)\">x</button>\r\n\t</div>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/map-facade/components/annotation-context-menu/annotation-context-menu.component.html
// module id = ../../../../../src/app/packages/map-facade/components/annotation-context-menu/annotation-context-menu.component.html
// module chunks = main